module.exports = __webpack_public_path__ + "gb.2a10cd05641109b0f632.svg";


//////////////////
// WEBPACK FOOTER
// /Users/andrescufari/Angular/lednube/theme/scss/icons/flag-icon-css/flags/gb.svg
// module id = ../../../../../theme/scss/icons/flag-icon-css/flags/gb.svg
// module chunks = styles